import { render, staticRenderFns } from "./LogoMbaa.vue?vue&type=template&id=062477b8&scoped=true"
import script from "./LogoMbaa.vue?vue&type=script&lang=js"
export * from "./LogoMbaa.vue?vue&type=script&lang=js"
import style0 from "./LogoMbaa.vue?vue&type=style&index=0&id=062477b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062477b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
